import client from '../base-api';

const serviceURL = '/send-email';

const sendEmailService = {

    getEmails(filterData: any) {
        return client.get(`${serviceURL}`, {params: filterData});
    },
    getEmailDetails(emailId: number) {
        return client.get(`${serviceURL}/${emailId}`);
    },
    resendEmail(emailId: number) {
        return client.put(`${serviceURL}/resend/${emailId}`);
    },

}

export default sendEmailService;